import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import { GetAllTE_PM_TypeOfWork } from "../../../../Redux/Reducers/ProjectInformationPage/ProjectManagementTeamMembers/DropDownForTypeOfWork";
import { GetAllTE_PM_NatureOfWork } from "../../../../Redux/Reducers/ProjectInformationPage/ProjectManagementTeamMembers/DropDownForNatutralOfWork";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import AddProjectManagementTeamMember from "../../../../Services/ProjectInformationPage/TeamMember/AddProjectManagementTeamMembers";
import UpdateProjectManagementTeamMember from "../../../../Services/ProjectInformationPage/TeamMember/UpdateProjectManagementTeamMembers";
import {
  GetOneProjectManagementTeamMembers,
  restValidateProjectManagementTeamMembers,
  ValidateProjectManagementTeamMembers,
} from "../../../../Redux/Reducers/ProjectInformationPage/ProjectManagementTeamMembers/indexOne";
import Swal from "sweetalert2";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import axios from "axios";
import loadConfig from "../../../../Services/apiService";


const AddEditProjectAdminTeam = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownTETypeOfWork: state.DropDownTETypeOfWork.DropDownTETypeOfWork,
      DropDownTENatureOfWork:
        state.DropDownTENatureOfWork.DropDownTENatureOfWork,
      OneProjectManagementTeamMembers:
        state.OneProjectManagementTeamMembers.OneProjectManagementTeamMembers,
      loadingOneProjectManagementTeamMembers:
        state.OneProjectManagementTeamMembers
          .loadingOneProjectManagementTeamMembers,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships,
      tE_MAinTeamMembersPreviousExperiencePartnershipsId:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships
          .tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        state.tE_MAinTeamMembersPreviousExperiencePartnershipsId
          ?.tE_TeamMembersPreviousExperiencePartnershipsId,

      OneProjectManagementTeamMembersValidate:
        state.OneProjectManagementTeamMembers
          .OneProjectManagementTeamMembersValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  //console.log(
  //   state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
  //   "state"
  // );
  // Gender options for dropdown
  const MaleOrFemale = [
    { gender: "ذكر", KeyValue: true },
    { gender: "انثى", KeyValue: false },
  ];
  // State for the project admin form

  const [ProjectAdminList, setProjectAdminList] = useState({
    tE_PM_ProjectManagementTeamMembersId:
      state.OneProjectManagementTeamMembers
        ?.tE_PM_ProjectManagementTeamMembersId,
    fourPartName: state.OneProjectManagementTeamMembers?.fourPartName,
    gender: state.OneProjectManagementTeamMembers?.gender,
    tE_PM_NatureOfWorkId:
      state.OneProjectManagementTeamMembers?.tE_PM_NatureOfWorkId,
    tE_PM_TypeOfWorkId:
      state.OneProjectManagementTeamMembers?.tE_PM_TypeOfWorkId,
    tE_TeamMembersPreviousExperiencePartnershipsId:
      state.OneProjectManagementTeamMembers
        ?.tE_TeamMembersPreviousExperiencePartnershipsId,
    idDocumentAttachment:
      state.OneProjectManagementTeamMembers?.idDocumentAttachment,
    cvDocumentAttachment:
      state.OneProjectManagementTeamMembers?.cvDocumentAttachment,
    tE_MAinTeamMembersPreviousExperiencePartnershipsId:
      state.tE_TeamMembersPreviousExperiencePartnershipsId,
  });
  // State for file attachments (ID Document, CV Document)
  const [IDDocumentAttachment, setIDDocumentAttachment] = useState();
  const [CVDocumentAttachment, setCVDocumentAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [fileChange2, setFileChange2] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();
  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson(); // Load config on component mount
  }, []);

  // Effect to fetch TypeOfWork data
  useEffect(() => {
    dispatch(GetAllTE_PM_NatureOfWork());
  }, []);
  // Effect to fetch NatureOfWork data
  useEffect(() => {
    dispatch(GetAllTE_PM_TypeOfWork());
  }, []);

  // const AddProjectManagement = async () => {
  //   await AddProjectManagementTeamMember(
  //     ProjectAdminList.fourPartName,
  //     ProjectAdminList.gender == "true" ? true : false,
  //     ProjectAdminList.tE_PM_NatureOfWorkId,
  //     ProjectAdminList.tE_PM_TypeOfWorkId,
  //     ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };
  // Function to add a project management team member
  const AddProjectManagement = async () => {
    const validationList = await dispatch(
      ValidateProjectManagementTeamMembers({
        fourPartName: ProjectAdminList.fourPartName,
        gender:
          ProjectAdminList.gender === "true"
            ? true
            : ProjectAdminList.gender === "false"
            ? false
            : null,
        tE_PM_NatureOfWorkId: ProjectAdminList.tE_PM_NatureOfWorkId,
        tE_PM_TypeOfWorkId: ProjectAdminList.tE_PM_TypeOfWorkId,
        idDocumentAttachment: ProjectAdminList.idDocumentAttachment,
        cvDocumentAttachment: ProjectAdminList.cvDocumentAttachment,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If no validation errors, add team member
    if (validationList.payload.length === 0) {
      // await AddProjectManagementTeamMember(
      //   ProjectAdminList.fourPartName,
      //   ProjectAdminList.gender == "true" ? true : false,
      //   ProjectAdminList.tE_PM_NatureOfWorkId,
      //   ProjectAdminList.tE_PM_TypeOfWorkId,
      //   ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId
      // );
      // $(".close-btn").trigger("click");
      // Swal.fire({
      //   position: "center",
      //   icon: "success",
      //   title: "تم اضافة المعلومات بنجاح",
      //   showConfirmButton: false,
      //   timer: 1500,
      //   // width: "500px",
      // });
      // dispatch(setRefreshTable());
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/TE_PM_ProjectManagementTeamMembers/AddTE_PM_ProjectManagementTeamMembersData`,
          {
            fourPartName: ProjectAdminList.fourPartName,
            gender: ProjectAdminList.gender == "true" ? true : false,
            tE_PM_NatureOfWorkId: ProjectAdminList.tE_PM_NatureOfWorkId,
            tE_PM_TypeOfWorkId: ProjectAdminList.tE_PM_TypeOfWorkId,
            file: IDDocumentAttachment,
            fileName: "IDDocumentAttachment",
            file2: CVDocumentAttachment,
            fileName2: "CVDocumentAttachment",
            IDDocumentAttachment: ProjectAdminList.idDocumentAttachment,
            CVDocumentAttachment: ProjectAdminList.cvDocumentAttachment,
            tE_TeamMembersPreviousExperiencePartnershipsId:
              ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click"); // Close modal after successful submission

          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم اضافة المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });

          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };

  // const UpdateProjectManagement = async () => {
  //   await UpdateProjectManagementTeamMember(
  //     ProjectAdminList.tE_PM_ProjectManagementTeamMembersId,
  //     ProjectAdminList.fourPartName,
  //     ProjectAdminList.gender == "true" ? true : false,
  //     ProjectAdminList.tE_PM_NatureOfWorkId,
  //     ProjectAdminList.tE_PM_TypeOfWorkId,
  //     ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };
  // Function to update an existing project management team member
  const UpdateProjectManagement = async () => {
    const validationList = await dispatch(
      ValidateProjectManagementTeamMembers({
        fourPartName: ProjectAdminList.fourPartName,
        gender: ProjectAdminList.gender == "true" ? true : false,
        tE_PM_NatureOfWorkId: ProjectAdminList.tE_PM_NatureOfWorkId,
        tE_PM_TypeOfWorkId: ProjectAdminList.tE_PM_TypeOfWorkId,
        idDocumentAttachment: ProjectAdminList.idDocumentAttachment,
        cvDocumentAttachment: ProjectAdminList.cvDocumentAttachment,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      // await UpdateProjectManagementTeamMember(
      //   ProjectAdminList.tE_PM_ProjectManagementTeamMembersId,
      //   ProjectAdminList.fourPartName,
      //   ProjectAdminList.gender === "true" || ProjectAdminList.gender == true
      //     ? true
      //     : ProjectAdminList.gender === "false" ||
      //       ProjectAdminList.gender == false
      //     ? false
      //     : null,
      //   ProjectAdminList.tE_PM_NatureOfWorkId,
      //   ProjectAdminList.tE_PM_TypeOfWorkId,
      //   ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId
      // );
      // $(".close-btn").trigger("click");
      // Swal.fire({
      //   position: "center",
      //   icon: "success",
      //   title: "تم تعديل المعلومات بنجاح",
      //   showConfirmButton: false,
      //   timer: 1500,
      //   // width: "500px",
      // });
      // dispatch(setRefreshTable());
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/TE_PM_ProjectManagementTeamMembers/UpdateTE_PM_ProjectManagementTeamMembersData`,
          {
            tE_PM_ProjectManagementTeamMembersId:
            ProjectAdminList.tE_PM_ProjectManagementTeamMembersId,
            fourPartName: ProjectAdminList.fourPartName,
            gender: ProjectAdminList.gender == "true" ? true : false,
            tE_PM_NatureOfWorkId: ProjectAdminList.tE_PM_NatureOfWorkId,
            tE_PM_TypeOfWorkId: ProjectAdminList.tE_PM_TypeOfWorkId,
            file: fileChange > 0 ? IDDocumentAttachment : null,
            fileName: fileChange > 0 ? "IDDocumentAttachment" : null,
            file2: fileChange2 > 0 ? CVDocumentAttachment : null,
            fileName2: fileChange2 > 0 ? "CVDocumentAttachment" : null,

            IDDocumentAttachment: ProjectAdminList.idDocumentAttachment,
            CVDocumentAttachment: ProjectAdminList.cvDocumentAttachment,
            tE_TeamMembersPreviousExperiencePartnershipsId:
              ProjectAdminList.tE_TeamMembersPreviousExperiencePartnershipsId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم تعديل المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };
  useEffect(() => {
    dispatch(restValidateProjectManagementTeamMembers());
  }, []);
  // Effect to fetch project management team member details if available
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneProjectManagementTeamMembers(
          props.tE_ProjectManagementTeamMembersId
        )
      );
    }
  }, [props.tE_ProjectManagementTeamMembersId]);
  useEffect(() => {
    // Effect to set project admin list based on fetched data or reset

    if (
      !state.loadingOneProjectManagementTeamMembers &&
      Object.keys(props).length != 0
    ) {
      setProjectAdminList({
        ...state.OneProjectManagementTeamMembers,
      });
    } else {
      setProjectAdminList({
        fourPartName: null,
        gender: null,
        tE_PM_NatureOfWorkId: null,
        tE_PM_TypeOfWorkId: null,
        expectedNumberOfBeneficiaries: null,
        idDocumentAttachment: null,
        cvDocumentAttachment: null,
        tE_TeamMembersPreviousExperiencePartnershipsId:
          state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      });
    }
  }, [state.OneProjectManagementTeamMembers]);

  //console.log(ProjectAdminList.fourPartName, "TheName");

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneProjectManagementTeamMembers ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="fourSyllablesName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setProjectAdminList({
                  ...ProjectAdminList,
                  fourPartName: e.target.value,
                });
              }}
              defaultValue={state.OneProjectManagementTeamMembers?.fourPartName}
              showValidationMessage={
                state.OneProjectManagementTeamMembersValidate
                  ? state.OneProjectManagementTeamMembersValidate.includes(
                      "fourSyllablesName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="Gender"
              show={true}
              disabled={shouldDisableFields}
              KeyText={"gender"}
              KeyValue={"KeyValue"}
              arrayOoptionList={MaleOrFemale}
              dropdownType={"normal"}
              onChange={(e) => {
                setProjectAdminList({
                  ...ProjectAdminList,
                  gender: e.target.value,
                });
              }}
              defaultValue={ProjectAdminList.gender}
              showValidationMessage={
                state.OneProjectManagementTeamMembersValidate
                  ? state.OneProjectManagementTeamMembersValidate.includes(
                      "Gender"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="NatureOfWork"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownTENatureOfWork}
              KeyText={"natureOfWorkNameAr"}
              KeyValue={"tE_PM_NatureOfWorkId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setProjectAdminList({
                  ...ProjectAdminList,
                  tE_PM_NatureOfWorkId: Number(e.target.value),
                });
              }}
              defaultValue={ProjectAdminList.tE_PM_NatureOfWorkId}
              showValidationMessage={
                state.OneProjectManagementTeamMembersValidate
                  ? state.OneProjectManagementTeamMembersValidate.includes(
                      "NatureOfWork"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="TypeOfWork"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownTETypeOfWork}
              KeyText={"typeOfWorkNameAr"}
              KeyValue={"tE_PM_TypeOfWorkId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setProjectAdminList({
                  ...ProjectAdminList,
                  tE_PM_TypeOfWorkId: Number(e.target.value),
                });
              }}
              defaultValue={ProjectAdminList.tE_PM_TypeOfWorkId}
              showValidationMessage={
                state.OneProjectManagementTeamMembersValidate
                  ? state.OneProjectManagementTeamMembersValidate.includes(
                      "TypeOfWork"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
             <div style={{ marginTop: "10px" }}>
              <label>
                مرفق وثيقة اثبات الشخصية
                <span className="star">*</span>
              </label>
              <div style={{ marginTop: "20px" }}>
                <AttachmentASFH
                  id={"IDDocumentAttachment"}
                  text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  AttachementType="IDDocumentAttachment"
                  singleFile={
                    state.OneProjectManagementTeamMembers?.idDocumentAttachment
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange(fileChange + 1);
                    setIDDocumentAttachment(e.target.files[0]);
                    setProjectAdminList({
                      ...ProjectAdminList,
                      idDocumentAttachment: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.OneProjectManagementTeamMembersValidate
                      ? state.OneProjectManagementTeamMembersValidate.includes(
                          "IDDocumentAttachment"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>
                السيرة الذاتية
                <span className="star">*</span>
              </label>
              <div style={{ marginTop: "10px" }}>
                <AttachmentASFH
                  id={"CVDocumentAttachment"}
                  text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  AttachementType="CVDocumentAttachment"
                  singleFile={
                    state.OneProjectManagementTeamMembers?.cvDocumentAttachment
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange2(fileChange2 + 1);
                    setCVDocumentAttachment(e.target.files[0]);
                    setProjectAdminList({
                      ...ProjectAdminList,
                      cvDocumentAttachment: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.OneProjectManagementTeamMembersValidate
                      ? state.OneProjectManagementTeamMembersValidate.includes(
                          "CVDocumentAttachment"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>
            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateProjectManagement()
                        : AddProjectManagement();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneProjectManagementTeamMembers} />
    </>
  );
};

export default AddEditProjectAdminTeam;
